module.exports = __webpack_public_path__ + "img/NorthDash_Cover_1.7c3de2fc.jpg";